export default __webpack_public_path__ + "static/media/0x9719d867a500ef117cc201206b8ab51e794d3f82.c9614a5a.svg";